import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GlobalGroupIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GlobalGroup",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.01 21.09c.35-1.1.55-2.36.55-3.67 0-5.57-3.62-10.29-8.64-11.94l-.09-.02C19.62 3.51 17.98 2 15.99 2s-3.63 1.51-3.84 3.44v.02c-5.11 1.67-8.73 6.39-8.73 11.96 0 1.31.2 2.57.57 3.76l-.02-.09c-.76.71-1.23 1.71-1.23 2.83 0 2.14 1.73 3.87 3.87 3.87.63 0 1.23-.15 1.76-.42h-.02C10.44 29.02 13.1 30 15.99 30s5.56-.99 7.67-2.65l-.03.02c.51.27 1.1.43 1.74.44h.02c2.14 0 3.87-1.73 3.87-3.87 0-1.13-.48-2.14-1.25-2.85M9.9 26a3.8 3.8 0 0 0 .58-2.04c0-2.14-1.73-3.87-3.87-3.87H6.6c-.26 0-.52.03-.77.08h.02a10.416 10.416 0 0 1 6.55-12.6l.07-.02c.63 1.33 1.96 2.24 3.5 2.24s2.87-.9 3.49-2.21v-.02c4.12 1.46 7 5.32 7 9.84 0 .97-.13 1.92-.38 2.81l.02-.07c-.22-.05-.48-.07-.75-.07-2.14 0-3.87 1.73-3.87 3.87v.05c0 .75.22 1.46.59 2.05v-.02c-1.7 1.23-3.81 1.96-6.1 1.96s-4.4-.74-6.12-1.98l.03.02Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27.29 29.57c-2.52 0-4.57-2.05-4.57-4.57s2.05-4.57 4.57-4.57 4.57 2.05 4.57 4.57-2.05 4.57-4.57 4.57m0-6.86C26.03 22.71 25 23.74 25 25s1.03 2.29 2.29 2.29 2.29-1.03 2.29-2.29-1.03-2.29-2.29-2.29M4.43 29.57c-2.52 0-4.57-2.05-4.57-4.57s2.05-4.57 4.57-4.57S9 22.48 9 25s-2.05 4.57-4.57 4.57m0-6.86c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29S6.72 26.26 6.72 25s-1.03-2.29-2.29-2.29M15.86 9c-2.52 0-4.57-2.05-4.57-4.57s2.05-4.57 4.57-4.57 4.57 2.05 4.57 4.57S18.38 9 15.86 9m0-6.86c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29 2.29-1.03 2.29-2.29-1.03-2.29-2.29-2.29"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.33 22.88q-.18 0-.36-.06c-.6-.2-.92-.85-.72-1.45.41-1.22.61-2.5.61-3.8 0-3.75-1.71-7.22-4.68-9.51-.5-.38-.59-1.1-.21-1.6.39-.5 1.1-.59 1.6-.21 3.54 2.73 5.57 6.85 5.57 11.32 0 1.55-.25 3.07-.73 4.52-.16.48-.61.78-1.08.78ZM2.73 18.14h-.05a1.14 1.14 0 0 1-1.09-1.19c.27-6.27 4.52-11.56 10.58-13.18.61-.16 1.24.2 1.4.81s-.2 1.24-.81 1.4a11.93 11.93 0 0 0-8.88 11.07c-.03.61-.53 1.09-1.14 1.09ZM15.86 31.86c-3.58 0-7-1.33-9.63-3.74-.47-.43-.5-1.15-.07-1.62.43-.46 1.15-.5 1.61-.07a12 12 0 0 0 12.27 2.39c.59-.22 1.25.08 1.47.67s-.08 1.25-.67 1.47c-1.59.59-3.26.89-4.98.89Z"
      })]
    })
  }));
};
GlobalGroupIcon.displayName = 'GlobalGroupIcon';